module.exports = __webpack_public_path__ + "assets/lawandorder-4.c3c8e717.svg";